var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuradoria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8Z",
    fill: "#194D48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C7.9342 15.0004 7.86897 14.9878 7.80805 14.9629C7.74713 14.938 7.69172 14.9013 7.645 14.855L2.295 9.5C2.10721 9.31332 2.00112 9.05979 2 8.795V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H6.795C7.05979 4.00112 7.31332 4.10721 7.5 4.295L12.855 9.645C12.9019 9.69148 12.9391 9.74678 12.9644 9.80771C12.9898 9.86864 13.0029 9.93399 13.0029 10C13.0029 10.066 12.9898 10.1314 12.9644 10.1923C12.9391 10.2532 12.9019 10.3085 12.855 10.355L8.355 14.855C8.30828 14.9013 8.25287 14.938 8.19195 14.9629C8.13103 14.9878 8.0658 15.0004 8 15ZM3 5V8.795L8 13.795L11.795 10L6.795 5H3Z",
    fill: "#194D48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.855 6.645L8.5 1.295C8.31332 1.10721 8.05979 1.00112 7.795 1H4C3.73478 1 3.48043 1.10536 3.29289 1.29289C3.10536 1.48043 3 1.73478 3 2V3H4V2H7.795L12.795 7L12.145 7.645L12.855 8.355L13.855 7.355C13.9019 7.30852 13.9391 7.25322 13.9644 7.19229C13.9898 7.13136 14.0029 7.06601 14.0029 7C14.0029 6.93399 13.9898 6.86864 13.9644 6.80771C13.9391 6.74678 13.9019 6.69148 13.855 6.645Z",
    fill: "#194D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuradoria);
export default __webpack_public_path__ + "static/media/curadoria.d98ff9dd4786060c0fd0d433492c0b2d.svg";
export { ForwardRef as ReactComponent };